<div class="message-container">
  <div class="message-nav-bar box">
    <div class="message-nav-bar-title">پیام ها</div>
    <div class="message-back" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="message-holder">
    <div class="message-wrapper" *ngIf="messages">
      <div
        class="message-item"
        *ngFor="let message of messages.suppotTickets; let i = index"
        (click)="goToMessagePage(message.id)"
      >
        <div
          class="message-item-header"
          [ngStyle]="{
            'border-top': i === 0 ? 'none' : ' 0.5px solid rgb(198, 198, 200);'
          }"
        >
          <p>{{ message.messages[0].text }}</p>
          <span> {{ getDate(message.createdAt) }}</span>
        </div>
        <div class="message-item-status">
          <div
            *ngIf="message.messages.length >= 2"
            [ngClass]="{
              unSeen: message.readByUser === false,
              seen: message.readByUser === true
            }"
          >
            <p class="message">(پاسخ داده شده)</p>
          </div>
          <div
            *ngIf="message.messages.length <= 1"
            [ngClass]="{
              unSeen: message.readByUser === false,
              seen: message.readByUser === true
            }"
          >
            <p class="message">(در انتظار پاسخ)</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
